import { prepareFormDataId } from '@/utils/form/prepareFormDataId'

function prepareObjectFormData (data) {
  const keyList = [
    'building',
    'customer',
    'general_contractor',
    'estimate_responsible',
    'status',
    'treaty'
  ]

  return prepareFormDataId(data, keyList)
}

export {
  prepareObjectFormData
}
